import React from "react";

import { ObservabilityPipelineHttpMetricsOverview } from "Api/observability/pipeline/types";

import * as S from "../style";
import ImpactTable from "../table";

import TimeRangeImpactChart from "./TimeRangeChart";

const impactCount = 10;

const TopUrlView = ({
  data
}: {
  data: ObservabilityPipelineHttpMetricsOverview | null | undefined;
}) => {
  return (
    <S.ImpactContainer>
      <S.ImpactWraper id="http-url-impact">
        <TimeRangeImpactChart
          impactCount={impactCount}
          httpMetricsOverview={data}
        />
      </S.ImpactWraper>
      <hr />
      <S.TopListWraper>
        <ImpactTable httpMetricsOverview={data} />
      </S.TopListWraper>
    </S.ImpactContainer>
  );
};

export default TopUrlView;
